// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `

.grupo-preferencias:last-child {
  margin-bottom: 0;
}

.categoria-titulo {
  margin: 0 0 0.25rem;
  }

.lista-preferencias {
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
}

.item-preferencia {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
}

.item-texto {
  flex: 1;
  min-width: 0;
}

.item-titulo-row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0.35rem;
}

.badge-obrigatorio {
  font-size: var(--app-font-size-0-7rem);
  font-weight: var(--app-font-weight-semibold);
  text-transform: uppercase;
  letter-spacing: 0.03em;
  color: var(--app-file-invalid);
  border: 1px solid var(--app-legacy-preferencia-notificacao-border);
  border-radius: 4px;
  padding: 0.15rem 0.45rem;
}

.toggle-preferencia {
  margin-top: 0.15rem;
}

.separador-grupos {
  opacity: 0.6;
}

@media (max-width: 575.98px) {
  .item-preferencia {
  flex-direction: column;
    align-items: stretch;
  }

  .toggle-preferencia {
    align-self: flex-start;
  }
}
`, "",{"version":3,"sources":["webpack://./src/app/main/notificacao/preferencia-notificacao/preferencia-notificacao.component.css"],"names":[],"mappings":";;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB;;AAEF;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,OAAO;EACP,YAAY;AACd;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,sCAAsC;EACtC,4CAA4C;EAC5C,yBAAyB;EACzB,sBAAsB;EACtB,8BAA8B;EAC9B,kEAAkE;EAClE,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE;EACA,sBAAsB;IACpB,oBAAoB;EACtB;;EAEA;IACE,sBAAsB;EACxB;AACF","sourcesContent":["\n\n.grupo-preferencias:last-child {\n  margin-bottom: 0;\n}\n\n.categoria-titulo {\n  margin: 0 0 0.25rem;\n  }\n\n.lista-preferencias {\n  display: flex;\n  flex-direction: column;\n  gap: 1.25rem;\n}\n\n.item-preferencia {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 1rem;\n}\n\n.item-texto {\n  flex: 1;\n  min-width: 0;\n}\n\n.item-titulo-row {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 0.5rem;\n  margin-bottom: 0.35rem;\n}\n\n.badge-obrigatorio {\n  font-size: var(--app-font-size-0-7rem);\n  font-weight: var(--app-font-weight-semibold);\n  text-transform: uppercase;\n  letter-spacing: 0.03em;\n  color: var(--app-file-invalid);\n  border: 1px solid var(--app-legacy-preferencia-notificacao-border);\n  border-radius: 4px;\n  padding: 0.15rem 0.45rem;\n}\n\n.toggle-preferencia {\n  margin-top: 0.15rem;\n}\n\n.separador-grupos {\n  opacity: 0.6;\n}\n\n@media (max-width: 575.98px) {\n  .item-preferencia {\n  flex-direction: column;\n    align-items: stretch;\n  }\n\n  .toggle-preferencia {\n    align-self: flex-start;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
